import BaseEntity from '../base/BaseEntity.model';
import UrlServicioHeader from './urlServicioHeader.model';

export default class TipoTramitePaso extends BaseEntity{
    public esPasoCierre?: boolean;
    public order?: number;
    public tipoRespuesta?: number;
    public serviceHandler?: string;
    public correos?: string; //email1@gmail|email1@gmail|email1@gmail - Enviar comprobante
    public urlServicio?: string; //jce.com.do - Compartir Datos
    public headers: Array<UrlServicioHeader> = [];
    constructor(
        public tipoTramiteId?: number,
        public nombre?: string,
        public codigo?: string,
        public institucionId?: number,
        public descripcion?: string,
    ) {
        super();
        this.init();
    }

    init() {
        this.id = undefined;
        this.order = 1;
        this.tipoRespuesta = 24;
        this.serviceHandler = String();
        this.headers = [];
        this.esPasoCierre = false;
    }
}